import Immutable from 'immutable';

import {
  START_LOADING_PRIVACY_AGREEMENT,
  PRIVACY_AGREEMENT_LOADING_SUCCESS,
  PRIVACY_AGREEMENT_LOADING_ERROR
} from '../actions/privacyAgreement';

const initialState = Immutable.fromJS({
  loading: false,
  privacy: ''
});

export default function(state = initialState, action) {
  switch (action.type) {
    case START_LOADING_PRIVACY_AGREEMENT:
      return state.set('loading', true);
    case PRIVACY_AGREEMENT_LOADING_SUCCESS:
      return state.merge({
        loading: false,
        privacy: action.privacy
      });
    case PRIVACY_AGREEMENT_LOADING_ERROR:
      return state.set('loading', false);
    default:
      return state;
  }
}

/* Selectors */

export function getPrivacyAgreement(state) {
  return state && state.getIn(['privacyAgreement', 'privacy']);
}

export function isPrivacyAgreementLoading(state) {
  return Boolean(state && state.getIn(['privacyAgreement', 'loading']));
}
